import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import CrudPage from "@/components/CrudPage";

export default function TabbedModule({ title, subtitle, tabs, testId }) {
  return (
    <div className="space-y-8" data-testid={testId}>
      <PageHeader title={title} subtitle={subtitle} />
      <Tabs defaultValue={tabs[0].key}>
        <TabsList className="bg-white border border-stone-200 flex-wrap h-auto">
          {tabs.map((t) => <TabsTrigger key={t.key} value={t.key} data-testid={`tab-${t.key}`}>{t.config.title}</TabsTrigger>)}
        </TabsList>
        {tabs.map((t) => (
          <TabsContent key={t.key} value={t.key} className="mt-6"><CrudPage key={t.key} config={t.config} /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
